import { TLD } from '../types';

export { MAIN_CATEGORIES } from './categories';

export const SERVICE_BASE_PATH = '/service/v1';
export const PRODUCT_CLICKOUT_PATH = `${SERVICE_BASE_PATH}/product/redirect`;
export const CONTENT_CLICKOUT_PATH = `${SERVICE_BASE_PATH}/content/redirect`;
export const IMPRESSION_TRACKING_PATH = `${SERVICE_BASE_PATH}/product/impression`;
export const TRACKING_ID_PATH = `${SERVICE_BASE_PATH}/id`;

export const ORIGINAL_URL_COOKIE_ENDPOINT = '/api/original-url-cookie';
export const DY_COOKIES_UPDATE_PATH = '/api/refresh-dy-cookies';
export const SET_COUNTRY_FILTER_STATUS_ENDPOINT = '/api/set-support-country-filter-status';
export const ACCEPT_CLIENT_SIDE_ERROR_LOGS = '/api/client-errors';

export const localSearchSupplement: {
  [key in TLD]: string;
} = {
  [TLD.DE]: 'lokale-suche',
  [TLD.FR]: 'magasins-a-proximite',
  [TLD.NL]: 'lokale-suche',
};
